var fn;
(function (fn) {
    fn.curry = function (func) {
        var numArgs = func.length;
        function curried(args) {
            return args.length >= numArgs
                ? func.apply(null, args)
                : function () { return curried(args.concat(Array.prototype.slice.apply(arguments))); };
        }
        return curried(Array.prototype.slice.apply(arguments, [1]));
    };
    fn.get = fn.curry((prop, obj) => obj[prop]);
    fn.first = fn.curry((pred, arr) => {
        for (var i = 0, len = arr.length; i < len; i++) {
            if (pred(arr[i]))
                return arr[i];
        }
        return null;
    });
    fn.groupBy = fn.curry((func, arr) => {
        var grouped = {};
        arr.forEach(obj => {
            var propVal = func(obj);
            if (propVal in grouped)
                grouped[propVal].push(obj);
            else
                grouped[propVal] = [obj];
        });
        return grouped;
    });
    fn.sum = fn.curry((func, arr) => {
        var sum = 0;
        arr.forEach((item) => {
            sum += func(item);
        });
        return sum;
    });
})(fn || (fn = {}));
//# sourceMappingURL=fn.js.map